import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Container,
  CircularProgress,
} from '@mui/material';
import { useAppBar } from '../../providers/AppBarProvider';
import { fetchById } from '../../utils/lib';
import { useTranslation } from 'react-i18next';
import { useConfig } from '../../providers/ConfigProvider';
import BottomSheet from '../../layouts/BottomSheet';
import EditIcon from "@mui/icons-material/Edit";
import PasswordIcon from "@mui/icons-material/Password";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from 'react-router-dom';
import PersonIcon from '@mui/icons-material/Person';
import axios from 'axios';
import { useAuth } from '../../providers/AuthProvider';
import { handleError } from '../../utils/lib';
import { useSnackbar } from '../../providers/SnackBarProvider';
import useConfirmDialog from '../../hooks/UseConfirmDialog';
import useUserStore from '../../store/userStore';

function ViewUser() {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const {updateTitle} = useAppBar();
  const {config, isLoadingConfig} = useConfig();
  const navigate = useNavigate();
  const { logout } = useAuth();
  const snackbar = useSnackbar();
  const { showDialog, ConfirmDialog } = useConfirmDialog();
  const { resetUser } = useUserStore();
  const { t } = useTranslation();

  useEffect(() => { 
    if (config) {
      setIsLoading(true);

      const fetchUser_ = async () => {
        const user = await fetchById(config.id, 'users');
        setUser(user);
        setIsLoading(false);
      };
      fetchUser_();
    }
  }, [config]);

  // Actualizar el title cuando cambie el user
  useEffect(() => {
    if (user) {
      updateTitle(user.thumb_url || '', user.name, user.email, false, PersonIcon, handleAvatarClick);
    }
  }, [user]);

  const handleAvatarClick = () => {
    if (user?.photo_url) {
      window.open(user.photo_url, '_blank');
    }
  };
  
  const handleEdit = () => {
    resetUser();
    navigate('/main/edit-user', { state: { updateUser: user } });
  };

  const handleChangePassword = () => {

  };

  const handleLogout = async () => {
    const userConfirmed = await showDialog(t('view.logoutConfirm'));
    
    if (!userConfirmed) return;

    try {
      await axios.post(
        `${import.meta.env.VITE_API_URL}users?logout_account`,
        {},
        { withCredentials: true }
      );
      document.cookie = 'access_token=; Max-Age=0; path=/;';
      document.cookie = 'access_token=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;';
      logout();
      navigate('/');
    } catch (error) {
      handleError(error, snackbar);
    }
  };

  if (isLoading || isLoadingConfig) return (
    <>
      <CircularProgress
        size={42}
        sx={{ position: 'absolute', top: '50%', left: '50%', marginTop: '-21px', marginLeft: '-21px' }}
      />
    </>
  );

  return (
    <Container maxWidth="xl">

      {/* Info Section */}
      <Box style={{ marginBottom: '16px' }}>
        <Typography variant="caption">{t('common.name')}</Typography>
        <Typography
          variant="body1"
          style={{ fontSize: '16px' }}
        >
          {user.name}
        </Typography>
      </Box>

      {/* Text fields with optional visibility */}
      {user.address && (
        <Box style={{ marginBottom: '16px' }}>
          <Typography variant="caption">{t('common.address')}</Typography>
          <Typography
            variant="body1"
            style={{ fontSize: '16px' }}
          >
            {user.address}
          </Typography>
        </Box>
      )}
      
      {user.region && (
        <Box style={{ marginBottom: '16px' }}>
          <Typography variant="caption">{t('common.region')}</Typography>
          <Typography
            variant="body1"
            style={{ fontSize: '16px' }}
          >
            {user.region.friendly_name}
          </Typography>
        </Box>
      )}

      {user.phone && (
        <Box style={{ marginBottom: '16px' }}>
          <Typography variant="caption">{t('common.phone')}</Typography>
          <Typography
            variant="body1"
            style={{ fontSize: '16px' }}
          >
            {user.phone}
          </Typography>
        </Box>
      )}

      <Box style={{ marginBottom: '16px' }}>
        <Typography variant="caption">{t('common.email')}</Typography>
        <Typography
          variant="body1"
          style={{ fontSize: '16px' }}
        >
          {user.email}
        </Typography>
      </Box>

      {user.notes && (
        <Box style={{ marginBottom: '16px' }}>
          <Typography variant="caption">{t('common.notes')}</Typography>
          <Typography
            variant="body1"
            style={{ fontSize: '16px' }}
          >
            {user.notes}
          </Typography>
        </Box>
      )}

      {config.login_type === 'EMAIL' && (
        <BottomSheet 
          zIndex={1001}
          buttonGroups={[
            {
              label: t('common.user'),
              buttons: [
                {
                  label: t('view.vetActionEdit'),
                  action: handleEdit,
                  icon: <EditIcon />
                },
                // {
                //   label: "Cambiar contraseña",
                //   action: handleChangePassword,
                //   icon: <PasswordIcon />
                // },
                {
                  label: t('view.logout'),
                  action: handleLogout,
                  icon: <LogoutIcon />
                },
              ]
            },
          ]}
        />
      )}

      <ConfirmDialog />

    </Container>
  );
}

export default ViewUser;